const WHATSAPP_EVENT_ID = process.env.REACT_APP_X_WHATSAPP_EVENT_ID;
const WHATSAPP_REACH_OUT_EVENT_ID = process.env.REACT_APP_X_WHATSAPP_REACH_OUT_EVENT_ID;
const API = `${process.env.REACT_APP_BACKEND_URL}/api/conversions`;

const getTwclid = () => {
  const fromUrl = new URLSearchParams(window.location.search).get('twclid');
  if (fromUrl) localStorage.setItem('twclid', fromUrl);
  return fromUrl || localStorage.getItem('twclid');
};

getTwclid();

export const trackWhatsAppClick = () => {
  const conversionId = crypto.randomUUID();
  if (window.twq) {
    window.twq('event', WHATSAPP_EVENT_ID, { conversion_id: conversionId });
    window.twq('event', WHATSAPP_REACH_OUT_EVENT_ID, {});
  }
  const body = JSON.stringify({ event: 'whatsapp_click', conversion_id: conversionId, twclid: getTwclid(), page_url: window.location.href });
  fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
};
